var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleCrossArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 13,
    viewBox: "0 0 26 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1418 12.2322H21.3321C21.3321 10.3972 19.6923 8.89575 17.6883 8.89575V8.89694C15.6113 8.89249 13.5267 8.80166 11.4614 8.6017C9.70219 8.43135 7.91973 8.18226 6.20249 7.78915C4.56096 7.41339 0.845825 6.45018 0.845825 4.44847C0.845825 2.44676 4.56096 1.48355 6.20249 1.10779C7.91973 0.714676 9.70219 0.465589 11.4614 0.295243C13.5267 0.0952756 15.6113 0.00444865 17.6883 0V0.743815C9.02558 0.816921 2.10091 2.44761 2.10091 4.44847C2.10091 6.44933 9.02558 8.08002 17.6883 8.15312V8.15431C19.6923 8.15431 21.3321 6.65289 21.3321 4.81782H22.1418C22.1418 6.65289 23.7815 8.15431 25.7856 8.15431V8.89575C23.7815 8.89575 22.1418 10.3972 22.1418 12.2322Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleCrossArrow);
export default __webpack_public_path__ + "static/media/female-cross-arrow.476121bbb2850edc226c1051d8e47c79.svg";
export { ForwardRef as ReactComponent };